// @flow

import styled from 'styled-components'

import { mediaMax } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'

const PriceAnnotation = styled.div`
  position: absolute;
  width: 80px;
  height: 30px;
  line-height: 30px;
  left: -22px;
  top: -37px;
  text-align: center;
  display: inline-block;
  border-radius: 3px;
  color: ${Colors.white};
  background-color: ${Colors.blueBdColor};
  cursor: pointer;
  font-size: 14px;
  border: 1px solid transparent;
  z-index: 1;

  &::before {
    position: absolute;
    margin-left: -8px;
    content: '';
    top: 100%;
    left: 50%;
    border: 8px solid transparent;
    height: 0;
    width: 0;
    border-top-color: ${Colors.blue};
    ${mediaMax.desktop`
      border: 6px solid transparent;
      margin-left: -6px;
    `};
  }

  &::after {
    position: absolute;
    margin-top: -1px;
    margin-left: -8px;
    content: '';
    top: 100%;
    left: 50%;
    border: 8px solid transparent;
    height: 0;
    width: 0;
    ${mediaMax.desktop`
      border: 6px solid transparent;
      margin-left: -6px;
    `};
  }

  &[data-balloon-color='pink'] {
    color: ${Colors.white};
    background-color: ${Colors.blueBdColor};

    &::before {
      border-top-color: ${Colors.blue};
      content: '';
    }
  }

  &[data-balloon-color='white'] {
    color: ${Colors.blue};
    border: 1px solid ${Colors.blue};
    background-color: ${Colors.white};

    &::before {
      border-top-color: ${Colors.blue};
      content: '';
    }

    &::after {
      border-top-color: ${Colors.white};
    }
  }

  &[data-balloon-color='gray'] {
    color: ${Colors.white};
    background-color: ${Colors.notesColor};

    &::before {
      border-top-color: ${Colors.notesColor};
    }
    &::after {
      border-top-color: ${Colors.notesColor};
    }
  }
`

export default PriceAnnotation



// WEBPACK FOOTER //
// ./src/components/molecules/SearchPriceAnnotation.jsx